var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 42,
    viewBox: "0 0 53 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1991 36.3999H42.0243V13.9416L26.5001 23.5666L10.9759 13.9416V36.3999H5.8012V5.59989H8.90604L26.5001 16.5082L44.0942 5.59989H47.1991V36.3999ZM47.1991 0.466553H5.8012C2.92922 0.466553 0.626465 2.75089 0.626465 5.59989V36.3999C0.626465 37.7613 1.17166 39.067 2.14211 40.0297C3.11256 40.9924 4.42877 41.5332 5.8012 41.5332H47.1991C48.5715 41.5332 49.8877 40.9924 50.8581 40.0297C51.8286 39.067 52.3738 37.7613 52.3738 36.3999V5.59989C52.3738 4.23844 51.8286 2.93276 50.8581 1.97007C49.8877 1.00738 48.5715 0.466553 47.1991 0.466553V0.466553Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailIcon);
export default __webpack_public_path__ + "static/media/gmail_icon.166f25e6.svg";
export { ForwardRef as ReactComponent };